export default "__VITE_ASSET__ClFGIS0J__"